/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileDgn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M15.955 11.887c.211 0 .421.019.628.055.211.037.409.092.593.165v.912a4.22 4.22 0 0 0-.628-.152 3.196 3.196 0 0 0-.552-.049c-.529 0-.936.14-1.222.421-.28.276-.42.675-.42 1.195 0 .579.122 1.014.366 1.303.248.285.626.428 1.132.428.193 0 .381-.011.565-.034.023-.003.046-.009.07-.012v-.97l-.85-.28v-.58h1.856v2.463a4.032 4.032 0 0 1-.517.192c-.18.05-.366.089-.559.112a4.197 4.197 0 0 1-.594.04c-.846 0-1.488-.225-1.925-.676-.432-.45-.648-1.113-.648-1.986 0-.539.106-.996.317-1.374.217-.381.525-.672.925-.87.405-.202.893-.303 1.463-.303zm-5.781.096c.547 0 1.005.095 1.373.284.368.188.644.469.828.841.189.373.282.835.282 1.387 0 .547-.094 1.007-.282 1.38a1.84 1.84 0 0 1-.828.842c-.368.188-.826.283-1.373.283H8.49v-5.017zm-.608 4.141h.594c.313 0 .57-.058.773-.173a1.1 1.1 0 0 0 .455-.538c.1-.244.152-.55.152-.918 0-.372-.051-.679-.152-.918a1.02 1.02 0 0 0-.455-.538c-.203-.12-.46-.179-.773-.179h-.594zm11.902-.875v-3.266h1.062V17h-.993l-2.167-3.269V17h-1.062v-5.017h.993z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileDgn as FileDgn };
